<template>
  <div id="recurly-3ds-container" :class="{ active: has3DSChallenge }"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useErrorsStore } from '@/store/ErrorsStore'

const errorsStore = useErrorsStore()
const { errors } = storeToRefs(errorsStore)

const has3DSChallenge = computed(() =>
  errors.value.some((error: any) => error.type === 'transaction' && error.transactionError?.code === 'three_d_secure_action_required')
)
</script>

<style lang="scss" scoped>
#recurly-3ds-container {
  background-color: var(--color-text-secondary);
  overflow: scroll;
  margin-top: $spacer-1;
  display: none;

  &.active {
    display: block;
    height: 400px;
  }
}
</style>
